<template>
    <div>
        <div class="row mb-4">
            <div class="col-md-12 mb-4">
                <!-- Active -->
                <h4 class="card-title" style="margin-top: 24px;"><b>Change Logs</b></h4>
                <div class="table-responsive">
                    <table id="log_table" class="display table table-striped table-bordered"
                        style="width:100%; text-align: left;">
                        <thead>
                            <tr>
                                <th scope="col">No.</th>
                                <th scope="col">User</th>
                                <th scope="col">Description</th>
                                <th scope="col">Timestamp</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(log, index) in data">
                                <th scope="row">{{ index + 1 }}</th>
                                <td>{{ log.causer }}</td>
                                <td>{{ log.description }}</td>
                                <td>{{ log.updated_at }}</td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>
        </div>
    </div>
</template>


<script>
// @ is an alias to /src
import axios from "axios";

export default {
    name: "SurveyReferralLogs",
    props: {
        data: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            eventLogs: []
        };
    },

    mounted() {
        // If "data" is already passed as a prop and not empty
        if (this.data.length) {
            this.initDataTable();
        }
    },
    watch: {
        data(newData) {
            if (newData.length) {
                this.$nextTick(() => {
                    this.initDataTable();
                });
            }
        }
    },
    methods: {
        initDataTable() {
            $("#log_table").DataTable({
                dom: "Bfrtip",
                buttons: ["excel"],
                lengthMenu: [
                    [10, 25, 50, -1],
                    ["10 rows", "25 rows", "50 rows", "Show all"]
                ],
            });
        }
    }

};
</script>
